import { pickLocale } from './api.js';

/**
 * Trust badges sidebar — every badge is sourced from the tenant's
 * CheckoutStrategy.display.trustBadges array. Operators add, remove, or
 * re-word badges in the admin dashboard; the shopper's next page-load
 * reflects the change. No hardcoded badge text in this component.
 */
export interface TrustBadgeDto {
  icon: string;
  title: Record<string, string>;
  subtitle: Record<string, string>;
}

export function TrustBadges(props: { items: TrustBadgeDto[]; locale: string }) {
  if (!props.items || props.items.length === 0) return null;
  return (
    <aside class="bg-surface-container-lowest border border-outline-variant rounded-xl p-4 lg:p-5 space-y-3 lg:space-y-4 hidden md:block md:sticky md:top-8">
      <p class="upg-eyebrow text-on-primary-container">Protocol Integrity</p>
      {props.items.map((b, i) => (
        <Badge
          key={`badge-${i}`}
          icon={b.icon}
          title={pickLocale(b.title, props.locale)}
          subtitle={pickLocale(b.subtitle, props.locale)}
        />
      ))}
    </aside>
  );
}

function Badge({ icon, title, subtitle }: { icon: string; title: string; subtitle: string }) {
  return (
    <div class="flex items-start gap-3">
      <div class="w-8 h-8 rounded bg-surface-container flex items-center justify-center flex-shrink-0">
        <span class="material-symbols-outlined" style={{ fontSize: '18px' }} aria-hidden="true">
          {icon}
        </span>
      </div>
      <div>
        <p class="text-body-sm font-bold leading-tight">{title}</p>
        <p class="text-[10px] text-on-surface-variant leading-tight mt-0.5">{subtitle}</p>
      </div>
    </div>
  );
}
